var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge-wrapper",class:{'pdf-badge-wrapper':_vm.mode==='pdf'}},[(_vm.id==0)?_c('span',{}):(_vm.id==1)?_c('span',{staticClass:"badge red"},[_vm._v("高风险")]):(_vm.id==2)?_c('span',{staticClass:"badge yellow"},[_vm._v("中风险")]):(_vm.id==3)?_c('span',{staticClass:"badge green"},[_vm._v("低风险")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }